import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from '@nuxtjs/composition-api'
import { PropType } from 'vue'
import {
  MenuCartEmpty,
  MenuCartPrice,
  MenuCartCallWaiter,
  MenuCartCallWaiterModal,
  useMenuModel,
  MenuDetailModal
} from '@entities/menu'
import { MenuCartList } from '@widgets/menu'
import { ModalBotton, AppButton } from '@shared/ui'
import MenuCartOrder from '@entities/menu/ui/MenuCartOrder.vue'
import { useRestaurantModel } from '@entities/restaurant'
import { IProduct } from '@entities/menu/model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuCart',
  props: {
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  },
  verticalScroll: {
    type: Number as PropType<number>,
    required: false,
    default: 0
  }
},
  emits: ['onClick'],
  setup(__props, { emit }) {

const props = __props



const menuModel = useMenuModel()
const restaurantModel = useRestaurantModel()



const cartCallWaiterModal = ref<boolean>(false)
const detailProduct = ref<IProduct | null>(null)
const detailCartItem = ref<any>(null)
const isDetailVisible = ref(false)
const showClearModal = ref<boolean>(false)

watch(() => menuModel.menuUser, () => {
  if (detailProduct.value) {
    menuModel.menuUser.forEach((i) => {
      i.products.forEach((j) => {
        if (detailProduct.value && j.id === detailProduct.value.id) {
          detailProduct.value = j
        }
      })
    })
  }
})

const toggleCart = () => {
  emit('onClick', 'menu')
}

const toggleCartCallWaiterModal = () => {
  cartCallWaiterModal.value = !cartCallWaiterModal.value
}

const handleGoToOrder = () => {
  emit('onClick', 'order')
}

const setDetailProduct = (data: { product: IProduct, cartItem?: any, openAsNew?: boolean }) => {
  detailProduct.value = data.product
  detailCartItem.value = data.cartItem || null
  // Сохраняем флаг openAsNew в cartItem для использования в MenuDetailModal
  if (data.cartItem && data.openAsNew) {
    detailCartItem.value = { ...data.cartItem, _openAsNew: true }
  }
  isDetailVisible.value = true
}

const closeDetail = () => {
  isDetailVisible.value = false
}

const handleAfterLeave = () => {
  detailProduct.value = null
  detailCartItem.value = null
}

const handleClearCart = () => {
  menuModel.clearCart()
  showClearModal.value = false
  if (typeof window !== 'undefined' && (window as any).ym) {
    (window as any).ym(process.env.YA_METRIK_ID, 'reachGoal', 'cartCleared')
  }
}

onMounted(() => {
  window.scroll(0, props.verticalScroll)
})

return { __sfc: true,props, menuModel, restaurantModel, emit, cartCallWaiterModal, detailProduct, detailCartItem, isDetailVisible, showClearModal, toggleCart, toggleCartCallWaiterModal, handleGoToOrder, setDetailProduct, closeDetail, handleAfterLeave, handleClearCart, MenuCartEmpty, MenuCartPrice, MenuCartCallWaiter, MenuCartCallWaiterModal, MenuDetailModal, MenuCartList, ModalBotton, AppButton, MenuCartOrder }
}

})